var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 60",
    width: 200,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 60,
    fill: "transparent"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 32,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 15,
    fontWeight: "bold",
    fill: "#1e293b",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Telangana RERA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/partner1.5e076a79d6795be0a0c0a1736c74ccb0.svg";
export { ForwardRef as ReactComponent };